export enum PermitCompononentEnum {
    Nothing = 0,
    Create = 1,
    Details = 2,
}
